import React from "react"
import { useLocation } from "@reach/router"
import {
  articleMetadata,
  normaliseArticlePath,
  breadcrumbsFor,
} from "../data/article-metadata"

export default function ArticleContext() {
  const { pathname } = useLocation()
  const article = articleMetadata[normaliseArticlePath(pathname)]
  if (!article) return null
  return (
    <div
      style={{
        paddingTop: 24,
        fontFamily: "Roboto, Arial, sans-serif",
        fontSize: 14,
        lineHeight: 1.7,
      }}
    >
      <nav aria-label="Breadcrumb">
        <ol
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4px 8px",
            listStyle: "none",
            padding: 0,
            margin: "0 0 8px",
          }}
        >
          {breadcrumbsFor(article).map((crumb, index, crumbs) => (
            <li key={crumb.url}>
              {index > 0 && (
                <span aria-hidden="true" style={{ marginRight: 8 }}>
                  ›
                </span>
              )}
              {index === crumbs.length - 1 ? (
                <span aria-current="page">{crumb.name}</span>
              ) : (
                <a href={crumb.url}>{crumb.name}</a>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <div style={{ color: "#536174" }}>
        Published by <a href="/about/">School Calendar</a>
        {article.author && (
          <>
            {" "}
            · By <a href={article.author.url}>{article.author.name}</a>
          </>
        )}
        {article.published && (
          <>
            {" "}
            · Published{" "}
            <time dateTime={article.published}>{article.published}</time>
          </>
        )}
        {article.modified && (
          <>
            {" "}
            · Updated{" "}
            <time dateTime={article.modified}>{article.modified.slice(0, 10)}</time>
          </>
        )}
        {article.reviewed && (
          <>
            {" "}
            · Content reviewed{" "}
            <time dateTime={article.reviewed}>{article.reviewed}</time>
          </>
        )}
        {" · "}
        <a href="/editorial-policy/">About our guides</a>
      </div>
    </div>
  )
}
